import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";

export const ContainerScroll = ({
    titleComponent,
    children,
}) => {
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
    });
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    const scaleDimensions = () => {
        return isMobile ? [0.7, 0.9] : [1.05, 1];
    };

    const rotate = useTransform(scrollYProgress, [0, 1], [20, 0]);
    const scale = useTransform(scrollYProgress, [0, 1], scaleDimensions());
    const translate = useTransform(scrollYProgress, [0, 1], [0, -40]);

    return (
        <div
            className="flex flex-col items-center justify-start relative w-full pt-8 pb-24"
            ref={containerRef}
        >
            <div
                className="w-full relative"
                style={{
                    perspective: "1000px",
                }}
            >
                <Header translate={translate} titleComponent={titleComponent} />
                <Card rotate={rotate} translate={translate} scale={scale}>
                    {children}
                </Card>
            </div>
        </div>
    );
};

export const Header = ({ translate, titleComponent }) => {
    return (
        <motion.div
            style={{
                translateY: translate,
            }}
            className="max-w-5xl mx-auto text-center mb-16 md:mb-24 relative z-10 px-4"
        >
            {titleComponent}
        </motion.div>
    );
};

export const Card = ({
    rotate,
    scale,
    translate,
    children,
}) => {
    return (
        <motion.div
            style={{
                rotateX: rotate,
                scale,
                boxShadow:
                    "0 0 #0000004d, 0 9px 20px #0000004a, 0 37px 37px #00000042, 0 84px 50px #00000026, 0 149px 60px #0000000a, 0 233px 65px #00000003",
            }}
            className="max-w-[280px] sm:max-w-[300px] md:max-w-sm aspect-[9/16] mx-auto w-full border-[6px] md:border-[10px] border-[#333] p-1 md:p-1.5 bg-[#222222] rounded-[40px] shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative z-0 origin-top"
        >
            {/* Front camera notch */}
            <div className="absolute top-[6px] md:top-[10px] left-1/2 -translate-x-1/2 w-20 md:w-28 h-6 bg-[#222222] rounded-b-2xl z-[100]"></div>

            <div className="h-full w-full overflow-y-auto hide-scroll-bar rounded-[30px] bg-white relative">
                {children}
            </div>
        </motion.div>
    );
};
